export const GET_EXAMPLE = '[EXAMPLE APP] GET EXAMPLE';

// export function getExample() {
//     console.log('action.getExample');
//     return (dispatch) => {
//         console.log("dispatch", GET_EXAMPLE);
//         dispatch({
//             type: GET_EXAMPLE
//         });
//     };
// }

// export function getExample() {
//     console.log('action.getExample');


//     return (dispatch, getState) => {
//         fetch('http://localhost:8081/student/read',
//             {
//                 headers: {
//                     'Accept': 'application/json, text/plain, */*',
//                     'Content-Type': 'application/json'
//                 },
//                 method: 'POST',
//                 body: JSON.stringify({ student_id: 1 })
//             })
//             .then((response) => response.json())
//             .then((responseData) => {
//                 dispatch({
//                     type: GET_EXAMPLE,
//                     payload: responseData
//                 })
//             });
//     }

    
//     // return {
//     //     type: GET_EXAMPLE,
//     // }
// }

export function getExample() {
    const data = {
        student_id: 1,
        FirstName: "Nick",
        LastName: "Bodtorf",
        Email: "nbodtorf@medprocure.com",
        Active: 1
    };

    return {
        type: GET_EXAMPLE,
        payload: data
    }

}


// WEBPACK FOOTER //
// src/main/content/example/store/actions/example.actions.js